import { ScopeButton } from '@monorepo/shared-lib';
import ScanTransactionsImage from 'assets/images/scan-transactions.svg';
import UploadTransactionsImage from 'assets/images/upload-transactions.svg';
import { StyledCard } from 'components/Custom/card';
import { CardDescSpan, CardTitleLargeSpan } from 'components/Custom/spans';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Provider } from 'store/api/enums';
import { Organisation } from 'store/organisation/models';
import { getProviderName } from 'utils/get-provider-name';

interface CaptureDocumentsPromotionPanelProps {
  organisation?: Organisation;
  onOpenCaptureTab: () => void;
}

export const CaptureDocumentsPromotionPanel: React.FC<
  CaptureDocumentsPromotionPanelProps
> = ({ organisation, onOpenCaptureTab }) => {
  const { t } = useTranslation();
  const provider = organisation?.providerName?.toLowerCase();
  const isExcelProvider = provider === Provider.EXCEL.toLowerCase();
  const imageSrc = isExcelProvider
    ? UploadTransactionsImage
    : ScanTransactionsImage;
  const descriptionKey = isExcelProvider
    ? 'organisation.capture-documents-promo-desc-excel'
    : 'organisation.capture-documents-promo-desc';
  const providerLabel = getProviderName(organisation?.providerName);

  return (
    <StyledCard
      $nopadding
      fullsize
      style={{
        boxShadow: '0px 4px 10px 0px #0000000D',
        marginBottom: '20px',
        display: 'flex',
        fontSize: 14,
        fontWeight: 400,
        padding: 0,
      }}
      width="100%"
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          flexFlow: 'row',
          alignContent: 'end',
          padding: '24px 24px 0 0',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexFlow: 'column',
            justifyContent: 'space-between',
            padding: '0 24px 24px 24px',
          }}
        >
          <CardTitleLargeSpan style={{ marginBottom: 10 }}>
            {t('organisation.capture-documents-promo-title')}
          </CardTitleLargeSpan>
          <CardDescSpan style={{ marginBottom: 16 }}>
            {t(descriptionKey, { provider: providerLabel })}
          </CardDescSpan>
          <ScopeButton
            type="primary"
            width="132px"
            height="40px"
            style={{ fontSize: '13px', fontWeight: 700 }}
            onClick={onOpenCaptureTab}
          >
            {t('organisation.get-started')}
          </ScopeButton>
        </div>

        <img
          alt=""
          src={imageSrc}
          style={{
            width: 253,
            maxWidth: '100%',
            height: 'auto',
            flexShrink: 0,
            alignSelf: 'flex-end',
          }}
        />
      </div>
    </StyledCard>
  );
};
